export default __webpack_public_path__ + "static/media/Filters.fe7ae8b1.png";